<template>
  <nav v-if="breadcrumbs && breadcrumbs.length > 0" class="breadcrumb is-small" aria-label="breadcrumbs">
    <ul>
      <li v-for="crumb in breadcrumbs" :key="crumb.url" class="breadcrumb__item" :class="{ 'is-active': crumb.active }">
        <router-link :to="crumb.url" class="breadcrumb__link">{{ crumb.label }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  apollo: {
    breadcrumbs: {
      query() {
        return this.$options.query.CurrentBreadcrumbs
      }
    }
  }
}
</script>

<graphql>
query CurrentBreadcrumbs {
  breadcrumbs @client {
    url
    label
    active
  }
}
</graphql>

<style lang="scss" scoped>
.breadcrumb {
  &__item {
    max-width: 300px;
  }

  &__link {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>